import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppRoute } from './utilities/constants/route';
import Editor from './routes/Editor/Editor';
import EditorProvider from './context/EditorProvider';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { useAuthorization } from './hooks/auth/useAuthorization';

const App: React.FC = () => {
  useAuthorization();

  return (
    <>
      <ScrollToTop />
      <EditorProvider>
        <Routes>
          <Route
            path={AppRoute.TOOLS_AI_HOMEWORK_HELP_ANSWER.path}
            element={<Editor />}
          />
        </Routes>
      </EditorProvider>
    </>
  );
};
export default App;
